import Phaser from 'phaser';
import { useEffect, useRef } from 'react';

class MyScene extends Phaser.Scene { 
  constructor(config) { 
    super(config); // Appeler le constructeur de la classe parente
    this.pokemonData = config.pokemonData; // Récupérer les données du Pokémon depuis la config
    this.period = config.period; // Récupérer l'heure depuis la config
}

    preload() {
        // // Charger la carte JSON exportée de Tiled

        this.load.tilemapTiledJSON('map', 'assets/maps/map.json');

        // // Charger les tilesets de la carte
        for (let row = 0; row <= 1; row++) {
            for (let col = 0; col <= 5; col++) {
                const name = `tile_${row}_${col}${this.period}`;
                    const path = `assets/maps/${name}.png`;
                    console.log(`Loading: ${path}`); // Debug
                    this.load.image(name, path);
            }
        }

        // // Charger le sprite du pkmn
        if (this.pokemonData) {
          this.load.spritesheet('starter', `assets/pokemon/walking_sprites/${this.pokemonData.number}.png`, {
              frameWidth: 32,  // La largeur de chaque frame dans la spritesheet du Pokémon
              frameHeight: 32,  // La hauteur de chaque frame dans la spritesheet du Pokémon
          });
        }
    }

    create() {
    //     // Charger la carte et les calques comme précédemment
        const map = this.make.tilemap({ key: 'map' });
        const tilesets = [];


        for (let row = 0; row <= 1; row++) { 
            for (let col = 0; col <= 5; col++) {
                const name = `tile_${row}_${col}${this.period}`;
                console.log(`Using tileset: ${name}`); // Débogage
                tilesets.push(map.addTilesetImage(name, name, 16, 16, 0, 0));
            }
        }

        console.log('Tilesets in map:', map.tilesets);
        console.log('Layers in map:', map.layers);
        map.createLayer('ground-1', tilesets, 0, 0); // Créer les calques de la carte
        map.createLayer('water-1', tilesets, 0, 0);
        map.createLayer('ground-2', tilesets, 0, 0);
        map.createLayer('path-1', tilesets, 0, 0);
        map.createLayer('borders', tilesets, 0, 0);
        map.createLayer('border-fix', tilesets, 0, 0);
        map.createLayer('half-shadows', tilesets, 0, 0);
        map.createLayer('bridge', tilesets, 0, 0);
        map.createLayer('garden-items-1', tilesets, 0, 0);
        map.createLayer('garden-items-2', tilesets, 0, 0);
        map.createLayer('tree-2', tilesets, 0, 0);
        map.createLayer('tree-1', tilesets, 0, 0);
        map.createLayer('tree-3', tilesets, 0, 0);
        map.createLayer('tree-4', tilesets, 0, 0);
        map.createLayer('tree-shadows', tilesets, 0, 0);
        map.createLayer('path-2', tilesets, 0, 0);
        map.createLayer('house', tilesets, 0, 0);
        map.createLayer('house-fix', tilesets, 0, 0);
        map.createLayer('extra-1', tilesets, 0, 0);
        map.createLayer('tower', tilesets, 0, 0);
        map.createLayer('extra-2', tilesets, 0, 0);
        map.createLayer('tree-5', tilesets, 0, 0);

        this.collisionLayer = map.createLayer('collisions', tilesets, 0, 0); // Créer le calque de collisions

        this.cameras.main.setBounds(0, 0, map.widthInPixels, map.heightInPixels); // Définir les limites de la caméra

        // Définir la position initiale de la caméra
        const startX = map.widthInPixels / 2 - this.cameras.main.width / 2; // Centrer horizontalement
        const startY = map.heightInPixels / 1 - this.cameras.main.height / 1; // Centrer verticalement
        this.cameras.main.setScroll(startX, startY); // Définir la position de la caméra
   
              // Activer le défilement avec la molette de la souris
       this.input.on('wheel', (pointer, gameObjects, deltaX, deltaY, deltaZ) => { // Gérer l'événement de la molette de la souris pour déplacer la caméra verticalement
         this.cameras.main.scrollY += deltaY * 0.5; // Ajustez la vitesse de défilement ici
       });
       this.input.on('pointerdown', (pointer) => { // Gérer l'événement de clic pour déplacer la caméra
         this.dragStart = { x: pointer.x, y: pointer.y }; // Enregistrer la position du clic
       });
       this.input.on('pointermove', (pointer) => {  // Gérer l'événement de déplacement pour déplacer la caméra
         if (pointer.isDown) { // Vérifier si le bouton de la souris est enfoncé
             const dx = pointer.x - this.dragStart.x; // Calculer la distance de déplacement en x
             const dy = pointer.y - this.dragStart.y; // Calculer la distance de déplacement en y
             this.cameras.main.scrollX -= dx; // Déplacer la caméra horizontalement
             this.cameras.main.scrollY -= dy; // Déplacer la caméra verticalement
             this.dragStart = { x: pointer.x, y: pointer.y }; // Mettre à jour la position du clic
         }
       });
     




        // Activer les collisions sur le calque "collision"
        this.collisionLayer.setCollisionByProperty({ collides: true }); 

        // Créer l'animation de marche pour le pkmn
        this.anims.create({ 
            key: 'walk-up', // Nom de l'animation
            frames: this.anims.generateFrameNumbers('starter', { start: 12, end: 15 }),  // Frames de marche
            frameRate: 7, // Vitesse de l'animation
            repeat: -1, // Répéter indéfiniment
        });
        this.anims.create({
            key: 'walk-down',
            frames: this.anims.generateFrameNumbers('starter', { start: 0, end: 3 }), 
            frameRate: 7,
            repeat: -1,
        });
        this.anims.create({
            key: 'walk-left',
            frames: this.anims.generateFrameNumbers('starter', { start: 4, end: 7 }),  
            frameRate: 7,
            repeat: -1,
        });
        this.anims.create({
            key: 'walk-right',
            frames: this.anims.generateFrameNumbers('starter', { start: 8, end: 11 }),  
            frameRate: 7,
            repeat: -1
        });

    // Ajouter le pkmn à la carte
        this.pkmn = this.physics.add.sprite(160, 660, 'starter');  // pkmn placé au centre
        this.pkmn.setSize(16, 16); // Taille du hitbox
        this.pkmn.setOffset(8, 16); // Décalage du hitbox

    // Faire en sorte que le pkmn entre en collision avec les murs
        this.physics.add.collider(this.pkmn, this.collisionLayer, this.handleCollision, null, this); // Gérer les collisions

    // Variables de contrôle du déplacement du pkmn
        this.isPaused = false;  // Marquer le pkmn comme non "en pause"
        this.isRunning = false; // Marquer le pkmn comme non "en train de courir"
        this.walkingDirection = ''; // Initialiser la direction de marche
        this.walkingDuration = 0; // Initialiser la durée de marche
        this.walkingMaxDuration = 10; // durée max des mouvements
        this.step = 24; // La taille d'un pas

    // Ajouter un événement qui appelle la fonction de déplacement
        this.time.addEvent({
            delay: 250, // Delai de 250 ms entre chaque déplacement
            callback: this.movepkmn, // Fonction de déplacement
            callbackScope: this, // Utiliser le contexte de la scène
            loop: true // Répéter indéfiniment
        });

        const shadowLayer = map.createLayer('shadows', tilesets, 0, 0); // Créer le calque des ombres        
    }

    getOppositeDirection(direction) { // Fonction pour obtenir la direction opposée
        switch (direction) { // Changer la direction en fonction de la direction actuelle
            case 'up': // Si la direction actuelle est "haut"
                return 'down'; // La modifier vers "bas"
            case 'down':
                return 'up';
            case 'left':
                return 'right';
            case 'right':
                return 'left';
            default:
                return 'down';  // Valeur par défaut, au cas où
        }
    }

    handleCollision(pkmn, collisionLayer) { // Fonction pour gérer les collisions 

        this.pkmn.setVelocity(0); // Arrêter le mouvement
        this.walkingDuration = 0; // Réinitialiser la durée de marche

        // Changer la direction immédiatement à l'opposée
        this.walkingDirection = this.getOppositeDirection(this.walkingDirection); // Changer la direction
        this.walkingDuration = Math.floor(Math.random() * this.walkingMaxDuration); // Assurer que le mouvement dure un certain temps
    }


    pausepkmn() { // Fonction pour mettre le pkmn en pause
        this.isPaused = true; // Marquer le pkmn comme "en pause"
        this.pkmn.anims.stop(); // Arrêter l'animation
        const pauseDuration = Math.random() * 2000 + 1000; // Durée de pause aléatoire entre 1 et 3 secondes
        this.time.delayedCall(pauseDuration, () => { // Reprendre le mouvement après la pause
            this.isPaused = false; // Marquer le pkmn comme non "en pause"
        });
    }


    movepkmn() {  // Fonction de déplacement du pkmn 
        if (this.isPaused) { // Vérifier si le pkmn est en pause
            this.pkmn.setVelocity(0); return 
        };

        if (this.walkingDuration <= 0) { // Choisir une nouvelle direction si la durée est écoulée
            if (Math.random() < 0.1) {  // 10% de chance de s'arrêter
                this.pausepkmn(); // Mettre le pkmn en pause
                return; 
            }
            
            this.walkingDirection = this.chooseNewDirection(); // Choisir une nouvelle direction
            this.walkingDuration = Math.floor(Math.random() * this.walkingMaxDuration) + 5; // Assurer que le mouvement dure un certain temps
    
            // Ajouter une chance pour que le Pokémon "courre" 
            if (Math.random() < 0.2) {  // 20% de chance de courir
                this.step = 32;  // Double de vitesse pour la course
                this.isRunning = true; // Marquer le pkmn comme en train de courir
                this.walkingDuration -= 5; // Réduire la durée de marche
                console.log('Run'); 
                
            } else {
                this.step = 24;  // Vitesse normale
            }
        } else {
            this.walkingDuration--; // Réduire la durée de marche
        }
        // Réinitialiser la vitesse du pkmn à chaque frame
        this.pkmn.setVelocity(0);


        let animFramerate = this.step / 3;  // Ajuster le framerate 


        switch (this.walkingDirection) { // Déplacer le pkmn dans la direction selectionnée
            case 'up': // Si la direction est "haut"
                this.pkmn.setVelocityY(-this.step);  // Déplacer le pkmn vers le haut
                this.pkmn.anims.play('walk-up', true); // Jouer l'animation de marche
                this.pkmn.anims.msPerFrame = 1000 / animFramerate;  // Modifier le framerate de l'animation
                break;
            case 'down':
                this.pkmn.setVelocityY(this.step);
                this.pkmn.anims.play('walk-down', true);
                this.pkmn.anims.msPerFrame = 1000 / animFramerate;
                break;
            case 'left':
                this.pkmn.setVelocityX(-this.step);
                this.pkmn.anims.play('walk-left', true);
                this.pkmn.anims.msPerFrame = 1000 / animFramerate;
                break;
            case 'right':
                this.pkmn.setVelocityX(this.step);
                this.pkmn.anims.play('walk-right', true);
                this.pkmn.anims.msPerFrame = 1000 / animFramerate;
                break;
            default:
                this.pkmn.setVelocity(0);
                this.pkmn.anims.stop();
                break;
        }

    }

    chooseNewDirection() { // Choisir une nouvelle direction aléatoire
    const directions = ['up', 'down', 'left', 'right'];
    return directions[Math.floor(Math.random() * directions.length)];
    }

}


const PhaserGame = ({ pokemon, period }) => { // On récupère les données du Pokémon et de l'heure
  const phaserRef = useRef(null); // Référence pour stocker l'instance du jeu

  useEffect(() => { 
      if (!pokemon) { // Vérifier si un Pokémon est sélectionné
          console.error('Aucun Pokémon sélectionné.'); // Vérifier que les données sont bien passées
          return;
      }

      const config = { // Configuration du jeu
        type: Phaser.WEBGL, // Utiliser le moteur de rendu WebGL
        width: 320,
        height: 640,
        parent: 'game-container', // ID du conteneur HTML
        scene: [new MyScene({ key: 'MyScene', pokemonData: pokemon, period })], // Passer les données du Pokémon et de l'heure
        physics: { 
            default: 'arcade', 
            arcade: { gravity: { y: 0 }, debug: false } 

        },
        scale: { 
            mode: Phaser.Scale.NONE, // Désactiver le redimensionnement automatique
            autoCenter: Phaser.Scale.CENTER_BOTH, // Centrer le jeu
            autoRound: true // Arrondir les valeurs de position
        }
    };

      // Créer une nouvelle instance du jeu Phaser
      const game = new Phaser.Game(config);

      // Stocker l'instance du jeu dans la référence
      phaserRef.current = game;

      // Nettoyage lorsque le composant est démonté
      return () => {
          game.destroy(true);
      };
  }, [pokemon, period]); // Re-créer le jeu si `pokemon` ou `period` change

};
  
  export default PhaserGame;




  